import React, { useEffect, useCallback, useState} from 'react';
import Group from './Group.js';
import Track from './Track.js';
import {connect} from 'react-redux';
import '../../../Mix2.scss';

const NewGroupsComponent = ({sequencerEngine, currentSubSequence}) => { 
    let groups = sequencerEngine.groups.groups;
    return (
        <div className="groups-component">
          {groups.map(
              x =>
                  x.tracks.length === 1 ?
                  <Track key={x.id} group={x} isAlone={true} track={x.tracks[0]}/> :
              <Group key={x.id} group={x}/>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      ... state.tracks.groupTracks,
      currentSubSequence: state.sequencer.currentSubSequence[props.sequencerEngine.engineId],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewGroupsComponent);
